exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo__image[data-v-d76c93ce]{height:25px;cursor:pointer}@media (min-width:1023px){.logo__image[data-v-d76c93ce]{height:35px}}", ""]);

// exports
